import React from 'react';
import { string } from 'prop-types';

const TitleImageSection = ({ title, description, imgSrc }) => (
  <>
    <h2>{ title }</h2>
    <p>{ description }</p>
    <img src={ imgSrc } className="img-fluid" alt="Persona relajada en una hamaca" />
  </>
);

TitleImageSection.propTypes = {
  title: string.isRequired,
  description: string.isRequired,
  imgSrc: string.isRequired,
};

export default TitleImageSection;
